import React from 'react';

import { InputWrapper } from './styles';
import { IconButton } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

interface QuantityInputProps {
  value?: number;
  minValue?: number;
  maxValue?: number;
  onChange: Function;
  className?: string;
  size?: number;
  color?: string;
  qtyDecimal?: boolean;
  edit?: boolean;
}

const QuantityInput: React.FC<QuantityInputProps> = ({
  value = 1,
  minValue = 0,
  maxValue = 100,
  onChange,
  className = '',
  color = 'transparent',
  size = 16,
  qtyDecimal = false,
  edit = false,
}) => {
  const changeQuantity = (num) => {
    const newValue = value + num;
    if (newValue < minValue || newValue > maxValue) return;
    onChange(newValue);
  };

  const onBlurInput = (val) => {
    if (!qtyDecimal) return;
    let newValue = parseFloat(val);
    if (isNaN(newValue)) {
      newValue = 0;
    }
    onChange(Number(newValue));
  };

  return (
    <InputWrapper size={size} color={color} className={className}>
      <IconButton
        data-testid="counter-minus"
        onClick={() => {
          changeQuantity(-1);
        }}>
        <Remove />
      </IconButton>
      <input
        type="number"
        className={`counter-input display ${qtyDecimal || edit ? '' : 'disabled'}`}
        value={value}
        onBlur={(e) => onBlurInput(e.target.value)}
        onChange={(e) => onChange(e.target.value)}
      />
      <IconButton
        data-testid="counter-plus"
        onClick={() => {
          changeQuantity(1);
        }}>
        <Add />
      </IconButton>
    </InputWrapper>
  );
};

export default QuantityInput;
